import RestService from '../services/rest';

async function withdrawMoney(cashout, customHeaders = {}) {
  return RestService.postAuthenticated('account/withdraw', cashout, customHeaders);
}

export default {
  withdrawMoney,
};
